import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { memo } from 'react';

function FundingCloseDateForm({ fundingCloseTimestamp }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Close Date:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="closeDate"
          id="closeDate"
          value={
            fundingCloseTimestamp
              ? moment.utc(fundingCloseTimestamp).local().format('MMM DD, YYYY H:mm (UTCZ)')
              : ''
          }
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingCloseDateForm);
